"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    EmailSolid: function() {
        return EmailSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const EmailSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M1 7.52068V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V7.5208L13.7205 14.0165C12.6875 14.7395 11.3127 14.7395 10.2797 14.0165L1 7.52068Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M22.8815 5.16243C22.519 3.91317 21.3662 3 20 3H4C2.63388 3 1.48104 3.91312 1.11851 5.16233L11.4266 12.378C11.7709 12.619 12.2292 12.619 12.5735 12.378L22.8815 5.16243Z",
            fill: "currentColor"
        })
    ]
}), "EmailSolid");
const _default = EmailSolid;
